/**
 * File Picker Modal Wrapper
 * Wrapper component that integrates with the global modal system
 */

import React, { useEffect } from "react";
import { FilePickerModal } from "./FilePickerModal";
import { useFilePickerModal } from "../store/file-picker-store";

export const FilePickerModalWrapper: React.FC = () => {
  const { isOpen } = useFilePickerModal();

  // Modal kapandığında Radix'in body'de bırakabileceği stilleri temizle.
  // NOT: Eskiden burada `if (!isOpen) return null` vardı; bu, Dialog'u anında
  // unmount ettiği için DialogContent içindeki kapanış temizliği hiç
  // çalışamıyor ve body pointer-events:none takılı kalıp tüm uygulamayı
  // tıklanamaz hale getirebiliyordu.
  useEffect(() => {
    if (isOpen) return;

    const cleanup = setTimeout(() => {
      document.body.style.removeProperty("pointer-events");
      document.body.style.removeProperty("overflow");
    }, 150);

    return () => clearTimeout(cleanup);
  }, [isOpen]);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      document.body.style.removeProperty("pointer-events");
      document.body.style.removeProperty("overflow");
    };
  }, []);

  // Dialog mount'ta kalır; kapalıyken AnimatePresence hiçbir şey render etmez.
  // Böylece kapanış animasyonu ve body temizlik effect'leri düzgün çalışır.
  return <FilePickerModal />;
};
